<!--
 * @Description: 执行历史
 * @Date: 2020-07-23 13:45:42
 * @LastEditTime: 2020-11-09 17:00:18
--> 

<template>
  <div class="container">
    <div class="top-search">
      <div class="search">
        <div class="content">
          <el-form :model="searchParams" inline >
            <el-form-item label="应用名称" prop="roleName" >
              <el-input
                v-model="searchParams.name"
                placeholder="请输入应用名称"
                clearable
                style="width: 240px"
                @keyup.enter.native="search"
              />
            </el-form-item>
            <el-form-item label="任务名称" prop="roleName" >
              <el-input
                v-model="searchParams.addr"
                placeholder="请输入任务名称"
                clearable
                style="width: 240px"
                @keyup.enter.native="search"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="search-btns">
          <div class="left-line" />
          <div class="right-btns mg">
            <el-button
              type="primary"
              icon="el-icon-search"
              round
              class="search-btn"
              @click="search"
              >搜索</el-button
            >
            <el-button
              icon="el-icon-refresh"
              round
              class="reset-btn"
              style="margin-left: 20px"
              @click="reset"
              >重置</el-button
            >
          </div>
          <div class="left-line" />
        </div>
      </div>
    </div>

    <div class="table-container">
      <!-- <div class="table-title">当前App：{{curAppName}}</div> -->

      <el-table
        :data="list.slice((pagination.page -1)*pagination.limit, pagination.page*pagination.limit)"
        v-loading="loading"
        empty-text="暂无数据"
        style="width: 100%"
        height="600"
        :row-style="{ background: '#FCFDFF' }"
        :header-cell-style="{ background: '#2d3a5b', color: '#ffffff' }"
      >
        <el-table-column
          align="center"
          label="应用"
          prop="app_name"
        ></el-table-column>
        <el-table-column
          align="center"
          label="任务"
          prop="task_name"
        ></el-table-column>
        <el-table-column
          align="center"
          label="日志开始时间"
          prop="start_ts"
        ></el-table-column>
        <el-table-column
          align="center"
          label="日志结束时间"
          prop="end_ts"
        ></el-table-column>
        <el-table-column label="操作" align="center" width="300">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-view"
              @click="rowDetail(row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      :total="pagination.total"
      :page.sync="pagination.page"
      :limit.sync="pagination.limit"
    />

    <!-- 详情 dialog -->
    <el-dialog :visible.sync="dialogDetail" title="执行历史详情">
      <el-form
        :model="formDetail"
        status-icon
        ref="ruleForm"
        label-width="100px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="App名称:">{{
              formDetail.app_name
            }}</el-form-item>
            <el-form-item label="任务名称:">{{
              formDetail.task_name
            }}</el-form-item>
            <el-form-item label="开始时间:">{{
              formDetail.start_ts
            }}</el-form-item>
            <el-form-item label="结束时间:">{{
              formDetail.end_ts
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否成功:">{{
              formDetail.is_success ? "是" : "否"
            }}</el-form-item>
            <el-form-item label="主机IP:">{{
              formDetail.exec_host_ip
            }}</el-form-item>
            <el-form-item label="日程Key:">{{
              formDetail.schedule_key
            }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetail = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { historyList } from "@/api/history.js";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      curAppName: "",
      dialogDetail: false,
      formDetail: {},
      loading: false,
      searchParams: {
        name: "",
        tel: "",
        addr: "",
      },
      pagination: {
        limit: 30,
        page: 1,
        total: 0,
      },
      list: [],
      curRowId: 0,
      formTemp: {
        name: "",
        plan_start_ts: "",
        plan_end_ts: "",
        retry_cnt: "",
        status: 0,
        task_key: "",
        app: "",
        task: "",
      },
      rules: {},
    };
  },

  created() {
    this.curAppName = this.$route.query.name;

    this.getList();
  },

  methods: {
    getList() {
      this.loading = true;
      historyList()
        .then((res) => {
          this.loading = false;
          this.list = res;
          this.pagination.total = res.length;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    search() {},
    reset() {},

    rowDetail(row) {
      this.dialogDetail = true;
      this.formDetail = row;
      // historyDelete().then();
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex($ali, $jus) {
  display: flex;
  align-items: $ali;
  justify-content: $jus;
}

.container {
  margin: 20px;
}

.top-search {
  display: flex;
  padding: 20px;
  width: 100%;
  // height: 100px;
  background: #ffffff;
  border: 1px solid #f0f3f7;
}
.table-container {
  min-height: 400px;
  margin-top: 20px;
  width: 100%;
  // border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 #eff2f7;
}
.search {
  // width: 1160px;
  // height: 160px;
  width: 100%;
  background: #ffffff;
  border-radius: 10px;
  // margin: 0 auto;
  //   overflow: hidden;
  .content {
    @include flex(center, space-between);
    border-radius: 4px;
    // height: 76px;
    width: 100%;
    margin: 0 auto;
  }
}
.search-btn {
  background-color: #2d3a5b;
  border: #2d3a5b;
}
.reset-btn {
  background-color: #ffffff;
  color: #2d3a5b;
  border: 1px solid #2d3a5b;
}
.table-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: #2d3a5b;
  background-color: #ffffff;
}
</style>